import { useEffect } from "react";
import { subscribeToPopState } from "./urlRouting.js";

export function useUrlRouting() {
  useEffect(() => subscribeToPopState(), []);
}
